import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Call SVG Icon
 */
export const Call: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 14 14"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M12.8375 2.80781L11.1734 1.14531C11.0561 1.02741 10.9165 0.933866 10.7629 0.870048C10.6092 0.80623 10.4445 0.773398 10.2781 0.773438C9.93906 0.773438 9.62031 0.90625 9.38125 1.14531L7.59063 2.93594C7.47272 3.05332 7.37918 3.19285 7.31536 3.34649C7.25154 3.50014 7.21871 3.66488 7.21875 3.83125C7.21875 4.17031 7.35156 4.48906 7.59063 4.72813L8.9 6.0375C8.59351 6.71306 8.16738 7.32764 7.64219 7.85156C7.11831 8.37803 6.50379 8.80571 5.82813 9.11406L4.51875 7.80469C4.40137 7.68679 4.26184 7.59324 4.1082 7.52942C3.95455 7.4656 3.78981 7.43277 3.62344 7.43281C3.28438 7.43281 2.96563 7.56563 2.72656 7.80469L0.934376 9.59375C0.81633 9.71135 0.722704 9.85113 0.658883 10.0051C0.595062 10.159 0.562306 10.324 0.562501 10.4906C0.562501 10.8297 0.695313 11.1484 0.934376 11.3875L2.59531 13.0484C2.97656 13.4312 3.50313 13.6484 4.04375 13.6484C4.15781 13.6484 4.26719 13.6391 4.375 13.6203C6.48125 13.2734 8.57031 12.1531 10.2563 10.4688C11.9406 8.78594 13.0594 6.69844 13.4109 4.58594C13.5172 3.94062 13.3031 3.27656 12.8375 2.80781Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
